export const GET_MODULES = "GET_MODULES";
export const GET_MODULE_BY_ID = "GET_MODULE_BY_ID";
export const UPDATE_MODULE = "UPDATE_MODULE";
export const DELETE_MODULE = "DELETE_MODULE";
export const CREATE_MODULE = "CREATE_MODULE";
export const GET_MODULE_LECTURES = "GET_MODULE_LECTURES";
